import * as actionCreators from '../../../../../actions'

import Button from '@doordash/component-button'
import { EmailField, PhoneField } from '@doordash/component-fields'
import { Modal } from '@doordash/component-modal'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'

import Form from '../../../../../utilities/Form'
import { push, Steps } from '../../../../../utilities/steps'
import { Error } from './styles'

import { connect } from 'react-redux'
import * as events from '../../../../../events'
import { validators } from '../../../../../utilities/validators'

import {
  AlreadyStartedEnum,
  AlreadyStartedSigningUpModal,
} from '../../../../../models/types'
import * as DA from '../../../../../typeModules/events'

import routes from '../../../../../routes'

import t from './strings'

type Props = {
  onSubmit?: (any) => Promise<any>
  onClose: any
  applicantUniqueLink?: string
  trackDasherContinueApplication?: (
    data?: DA.DasherContinueApplication
  ) => Promise<any>
  alreadyStartedSigningUpModal?: AlreadyStartedSigningUpModal
  phoneCountry?: string
  experiments?: any
}

export class StartedSigningUpModal extends React.Component<Props> {
  public static fields = {
    phoneNumber: '',
    email: '',
  }

  public static validators = {
    phoneNumber: validators.phoneNumber,
    email: validators.email,
  }

  public static defaultProps = {
    phoneCountry: 'US',
  }

  public state = {
    error: '',
    nationalPhoneNumber: '',
    phoneCountry: '',
  }

  public componentDidMount() {
    const {
      trackDasherContinueApplication,
      alreadyStartedSigningUpModal,
    } = this.props

    trackDasherContinueApplication({
      action: DA.EventActions.Rendered,
      name: alreadyStartedSigningUpModal.type,
    })
  }

  public handleSubmit = async applicationData => {
    const { onSubmit } = this.props

    try {
      this.setState({ error: '' })
      const result = await onSubmit(applicationData)

      push(result.uniqueLink, Steps.ProfileSetup)
    } catch (error) {
      if (typeof error === 'string') {
        return this.setState({ error })
      }
      throw error
    }
  }

  public handleReturnToApplicationLoggedIn(applicantUniqueLink) {
    const { trackDasherContinueApplication } = this.props
    trackDasherContinueApplication({
      action: DA.EventActions.Clicked,
      name: AlreadyStartedEnum.LoggedIn,
    })

    window.location.replace(routes.application.path + applicantUniqueLink)
  }

  public render() {
    const { alreadyStartedSigningUpModal, applicantUniqueLink } = this.props
    const { error } = this.state

    if (
      alreadyStartedSigningUpModal.email ||
      alreadyStartedSigningUpModal.phoneNumber
    ) {
      StartedSigningUpModal.fields.email = alreadyStartedSigningUpModal.email
      StartedSigningUpModal.fields.phoneNumber =
        alreadyStartedSigningUpModal.phoneNumber
    }

    const type = alreadyStartedSigningUpModal.type

    let title
    let description
    switch (type) {
      case AlreadyStartedEnum.ExistingCredentials:
        title = t.h1Existing()
        description = t.descriptionExisting()
        break
      case AlreadyStartedEnum.LoggedIn:
        title = t.h1LoggedIn()
        description = t.descriptionLoggedIn()
        break
      default:
        title = t.h1()
        description = t.description()
    }

    return (
      <Modal
        title={title}
        onClose={this.props.onClose}
        isFullScreenOnMobile={false}
      >
        <StackChildren>
          <Text>{description}</Text>
          <Form
            fields={StartedSigningUpModal.fields}
            validators={StartedSigningUpModal.validators}
            onSubmit={this.handleSubmit}
          >
            {(fields, handleChange, handleSubmit, { isLoading }) => (
              <form onSubmit={handleSubmit}>
                <StackChildren>
                  {type === AlreadyStartedEnum.LoggedIn &&
                  applicantUniqueLink ? (
                    <Button
                      tag="a"
                      onClick={() =>
                        this.handleReturnToApplicationLoggedIn(
                          applicantUniqueLink
                        )
                      }
                    >
                      {t.resumeApplicationPrimaryAction()}
                    </Button>
                  ) : (
                    <React.Fragment>
                      <EmailField
                        type="email"
                        placeholder={t.email()}
                        autoComplete="email"
                        onChange={val => handleChange('email', val)}
                        label="Email"
                        isLabelHidden
                        autoFocus
                        {...fields.email}
                      />
                      <PhoneField
                        isInternationalEnabled
                        type="tel"
                        placeholder={t.phone()}
                        onChange={(unformatted, formatted) => {
                          this.setState({
                            nationalPhoneNumber: unformatted,
                          })
                          handleChange('phoneNumber', formatted.number.number)
                        }}
                        onCountryChange={(
                          countrySelected,
                          unformatted,
                          formatted
                        ) => {
                          this.setState({
                            phoneCountry: countrySelected,
                            nationalPhoneNumber: unformatted,
                          })
                          handleChange('phoneNumber', formatted.number.number)
                        }}
                        autoComplete="tel"
                        label="Phone Number"
                        isLabelHidden
                        value={
                          this.state.nationalPhoneNumber ||
                          fields.phoneNumber.value
                        }
                        currentCountry={
                          this.state.phoneCountry
                            ? this.state.phoneCountry
                            : this.props.phoneCountry
                        }
                        error={fields.phoneNumber.error}
                      />
                      {error && (
                        <Error isSquished>
                          <Text size={Text.Sizes.S12}>{error}</Text>
                        </Error>
                      )}
                      <Button
                        onClick={async () => {
                          try {
                            await handleSubmit()
                          } catch (e) {
                            console.warn(e)
                          }
                        }}
                        state={
                          isLoading
                            ? Button.States.Loading
                            : Button.States.Default
                        }
                      >
                        {t.continue()}
                      </Button>
                    </React.Fragment>
                  )}
                </StackChildren>
              </form>
            )}
          </Form>
        </StackChildren>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  alreadyStartedSigningUpModal: state.alreadyStartedSigningUpModal,
  applicantUniqueLink: state.applicantUniqueLink,
  experiments: state.experiments,
  phoneCountry: state.country,
})

const mapDispatchToProps = {
  trackDasherContinueApplication: events.trackDasherContinueApplication,
  onSubmit: actionCreators.findDasherApplication,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartedSigningUpModal)
